import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navbar-overlay" }
const _hoisted_2 = { class: "d-none d-md-flex carousel-caption web" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "slide-content" }
const _hoisted_6 = { class: "d-flex flex-column d-md-none carousel-caption mobile slide-container-mobile" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "slide-content-mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TeoPathNavBar = _resolveComponent("TeoPathNavBar")!
  const _component_CalendlyPopup = _resolveComponent("CalendlyPopup")!
  const _component_b_carousel_slide = _resolveComponent("b-carousel-slide")!
  const _component_b_carousel = _resolveComponent("b-carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TeoPathNavBar, { scrolledPastCarousel: _ctx.scrolledPastCarousel }, null, 8, ["scrolledPastCarousel"])
    ]),
    _createVNode(_component_b_carousel, {
      id: "carousel",
      controls: true,
      indicators: false,
      background: "#ababab",
      interval: 5000,
      "img-height": "768",
      class: "mb-4",
      modelValue: _ctx.activeSlide,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeSlide) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
          return (_openBlock(), _createBlock(_component_b_carousel_slide, {
            key: index,
            "img-src": slide.backgroundImg,
            active: index === _ctx.activeSlide
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: slide.slideImg,
                    alt: "Slide image",
                    class: "slide-image"
                  }, null, 8, _hoisted_4),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", null, _toDisplayString(slide.caption), 1),
                      _createElementVNode("p", null, _toDisplayString(slide.text), 1),
                      _createVNode(_component_CalendlyPopup)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: slide.slideImg,
                  alt: "Slide image",
                  class: "slide-image-mobile"
                }, null, 8, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h3", null, _toDisplayString(slide.caption), 1),
                  _createElementVNode("p", null, _toDisplayString(slide.text), 1),
                  _createVNode(_component_CalendlyPopup)
                ])
              ])
            ]),
            _: 2
          }, 1032, ["img-src", "active"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}